// Shared labels/colours for the audit trail (Dashboard, Activity, Customer report).
export const ACTION_META = {
  login: { label: 'Login', color: '#10b981' },
  login_failed: { label: 'Failed login', color: '#ef4444' },
  otp_failed: { label: 'OTP email failed', color: '#ef4444' },
  customer_created: { label: 'Customer added', color: '#64748b' },
  customer_updated: { label: 'Customer edited', color: '#f59e0b' },
  customer_deleted: { label: 'Customer deleted', color: '#ef4444' },
  order_created: { label: 'Order created', color: '#3b82f6' },
  order_edited: { label: 'Order edited', color: '#f59e0b' },
  order_ready: { label: 'Order ready', color: '#0ea5e9' },
  order_delivered: { label: 'Delivered', color: '#059669' },
  order_marked_paid: { label: 'Marked paid', color: '#10b981' },
  bill_created: { label: 'Bill created', color: '#8b5cf6' },
  bill_edited: { label: 'Bill edited', color: '#f59e0b' },
  bill_deleted: { label: 'Bill deleted', color: '#ef4444' },
  payment_received: { label: 'Payment', color: '#10b981' },
  payment_deleted: { label: 'Payment deleted', color: '#ef4444' },
  staff_added: { label: 'Staff added', color: '#6366f1' },
  staff_removed: { label: 'Staff removed', color: '#ef4444' },
  staff_activated: { label: 'Staff activated', color: '#10b981' },
  staff_deactivated: { label: 'Staff disabled', color: '#f59e0b' },
  staff_edited: { label: 'Staff edited', color: '#6366f1' },
  staff_password_reset: { label: 'Password reset', color: '#6366f1' },
  cutting_assigned: { label: 'Sent for cutting', color: '#0ea5e9' },
  cutting_unassigned: { label: 'Cutting removed', color: '#94a3b8' },
  cutting_status: { label: 'Cutting status', color: '#0ea5e9' },
  fabric_used: { label: 'Cloth cut', color: '#0891b2' },
  fabric_undo: { label: 'Cloth entry removed', color: '#f59e0b' },
};

export const roleLabel = (r) => ({ admin: 'Admin', employee: 'Employee', cutter: 'Cutting', superadmin: 'Super Admin' }[r] || r || '');

export const fmtDateTime = (d) => (d
  ? new Date(d).toLocaleString('en-GB', { timeZone: 'Asia/Riyadh', day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true })
  : '—');

export const FIELD_LABELS = {
  fullNameLabel: 'Dress name', suitQuantity: 'Quantity', type: 'Garments', orderType: 'Order type', clothLabel: 'Cloth',
  clothLabelOther: 'Cloth (other)', length: 'Length', chest: 'Chest', middle: 'Middle', shoulder: 'Shoulder', arm: 'Arm',
  kback: 'K-Back', neck: 'Neck', head: 'Head', pantLength: 'Pant length', waist: 'Waist', hip: 'Hip', thigh: 'Thigh',
  knee: 'Knee', bottom: 'Bottom', round: 'Round', price: 'Price', discount: 'Discount', advance: 'Advance', paymentType: 'Payment type',
  deliveryDate: 'Delivery date', extraInformation: 'Notes', napel: 'Napel', collarPoint: 'Collar point', collar: 'Collar',
  chestStyle: 'Chest style', frontStyle: 'Front style', namePlate: 'Name plate', frontPocket: 'Front pocket',
  sleevePocket: 'Sleeve pocket', rutba: 'Rutba', flop: 'Flop', cuffStyle: 'Cuff style', nameEmbroidery: 'Name embroidery',
  buttonSize: 'Button size', pleats: 'Pleats', pantWaistStyle: 'Pant waist style', pantBottomStyle: 'Pant bottom style',
  pantPocketStyle: 'Pant pocket style', extraItems: 'Extra items', shirtPrice: 'Shirt price', pantPrice: 'Pant price',
  name: 'Name', phone: 'Phone', city: 'City', email: 'Email', total: 'Total', subtotal: 'Subtotal', advancePaid: 'Advance paid',
  status: 'Status', items: 'Items', notes: 'Notes', isReady: 'Ready', isDelivered: 'Delivered', suitQty: 'Quantity',
};
export const fieldLabel = (f) => FIELD_LABELS[f] || f;
